import { AdminPortalB2BProducts } from '@stytch/react/b2b/adminPortal';
import { AuthFlowType, B2BOAuthProviders, B2BProducts } from '@stytch/vanilla-js';
import { DEFAULT_SESSION_DURATION_MINUTES } from '../sessionPolicy';

type Role = {
  role_id: string;
  description: string;
};

const resolveRedirectUrl = () => {
  const envRedirect = (import.meta.env.VITE_STYTCH_REDIRECT_URL as string | undefined)?.trim();
  if (envRedirect) return envRedirect;
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/`;
  }
  return undefined;
};

const redirectURL = resolveRedirectUrl();

export const adminPortalConfig = {
  allowedAuthMethods: [
    AdminPortalB2BProducts.emailMagicLinks,
    AdminPortalB2BProducts.sso,
    AdminPortalB2BProducts.oauthGoogle,
    AdminPortalB2BProducts.oauthMicrosoft,
  ],
  getRoleDescription: (role: Role) => {
    if (role.role_id === 'stytch_admin') {
      return 'Able to manage settings and members';
    } else if (role.role_id === 'stytch_member') {
      return 'Able to view settings and members, but cannot edit';
    } else {
      return role.description;
    }
  },
  getRoleDisplayName: (role: Role) => {
    if (role.role_id === 'stytch_admin') {
      return 'Admin';
    } else if (role.role_id === 'stytch_member') {
      return 'Member';
    } else {
      return role.role_id;
    }
  },
};

export const discoveryConfig = {
  products: [B2BProducts.oauth],
  sessionOptions: {
    sessionDurationMinutes: DEFAULT_SESSION_DURATION_MINUTES,
    // Ensure we get session tokens in the response
    sessionCustomClaims: {},
  },
  oauthOptions: {
    providers: [{ type: B2BOAuthProviders.Google }, { type: B2BOAuthProviders.Microsoft }],
    // Default to current origin callback if none provided via env
    discoveryRedirectURL: redirectURL,
  },
  authFlowType: AuthFlowType.Discovery,
};

export const adminPortalStyles = {
  fontFamily: 'IBM Plex Sans',
};

export const discoveryStyles = {
  fontFamily: 'IBM Plex Sans',
  container: {
    width: '500px',
  },
};
